
export const normalizePath = (path: string): string => {
  const urlPath = (path || '').trim().toLowerCase();
  return urlPath.length > 1 && urlPath.endsWith('/')
    ? urlPath.slice(0, -1)
    : urlPath;
};

export const browserNavigatation = (e: Event) => {
  if (
    process.client &&
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  ) {
    const target = e.currentTarget as HTMLAnchorElement;
    if (target?.href) {
      globalThis.window.location.href = target.href;
    }
  }
};
